import { IPhxAxTitleAnnouncerDelegate } from './../../types';
import { ICommand } from 'core-ts-types';
import { MemberDatasource } from '../../datasources/member_datasource';

export class OopsController {
  constructor(
    $state: ng.ui.IStateService,
    loadMemberConfigurationCommand: ICommand,
    phxAxTitleAnnouncerDelegate: IPhxAxTitleAnnouncerDelegate,
    ngMemberDatasource: MemberDatasource,
    public $stateParams: ng.ui.IStateParamsService
  ) {
    const member_data = ngMemberDatasource.read();
    loadMemberConfigurationCommand().then((response: any) => {
      phxAxTitleAnnouncerDelegate.announceTitle(`Transfer to ${member_data.core_config.short_name}`);
    });
    $stateParams['explanation'] = $stateParams['explanation'] || 'This issue is being addressed as soon as possible.';
  }
}

angular.module('capability-ng-global').controller('ngOopsController', OopsController);



// WEBPACK FOOTER //
// ./app/lib/global/views/oops/oops.ts